import { InjectionToken } from '@angular/core';

export * from './lib/analytics/analytics.service';
export * from './lib/analytics/analytics.types';
export * from './lib/analytics/track-click.directive';
export * from './lib/shared-util-segment.module';

export const PAGE_CONTEXT = new InjectionToken<string>('PageContext');
